import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './helpbox.styl'

class HelpBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const targetEl = document.getElementById(e.currentTarget.dataset.targetId);
    window.scroll(0, targetEl.offsetTop - 40);
  }

  render(){
    return (
      <div className="help-box z-depth-1" onClick={ this.handleClick } data-target-id={ '#' + this.props.targetId }>
        <div>
          <span className="help-box__title">{ this.props.title }</span>
          <i className="help-box__arrow fa fa-chevron-down" aria-hidden="true"></i>
        </div>
      </div>
    );
  }
}

export default HelpBox;



// WEBPACK FOOTER //
// ./src/components/helpboxes/helpbox/HelpBox.js